import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"
import { format } from "date-fns"
import { cn } from "@/lib/utils"

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  const isRange = props.mode === "range";

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-4", className)}
      classNames={{
        months: "flex flex-col sm:flex-row gap-8",
        month: "flex flex-col gap-4",
        month_caption: "flex justify-center pt-1 relative items-center h-14",
        caption_label: "hidden",
        nav: "absolute inset-x-2 top-3 flex justify-between items-center pointer-events-none",
        button_previous: "pointer-events-auto h-8 w-8 border border-slate-200 rounded-md flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-50 transition-all",
        button_next: "pointer-events-auto h-8 w-8 border border-slate-200 rounded-md flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-50 transition-all",
        month_grid: "w-full border-collapse",
        weekdays: "flex",
        weekday: "w-10 h-8 text-[11px] font-bold text-slate-400 uppercase tracking-wider flex items-center justify-center",
        week: "flex w-full",
        // Outer cell — modifier classes (range_start, range_end, range_middle, selected) are applied HERE in v9
        day: "w-10 h-10 p-0 relative flex items-center justify-center",
        // Inner button — base styles only
        day_button: "w-9 h-9 rounded-full flex items-center justify-center text-sm font-medium text-slate-600 hover:bg-slate-100 transition-all focus-visible:outline-none cursor-pointer",
        // In v9 these apply to the outer `day` td, so use [&>button] to style the inner button
        selected: isRange
          ? "" // range classes handle it
          : "[&>button]:bg-[#143A62] [&>button]:text-white [&>button]:hover:bg-[#1e3a5f]",
        today: "[&>button]:font-black [&>button]:text-[#143A62]",
        outside: "opacity-40",
        disabled: "opacity-30 pointer-events-none",
        range_start: "bg-blue-100 rounded-l-full [&>button]:bg-[#143A62] [&>button]:text-white [&>button]:rounded-full [&>button]:shadow-md [&>button]:hover:bg-[#1e3a5f]",
        range_end:   "bg-blue-100 rounded-r-full [&>button]:bg-[#143A62] [&>button]:text-white [&>button]:rounded-full [&>button]:shadow-md [&>button]:hover:bg-[#1e3a5f]",
        range_middle:"bg-blue-100 rounded-none [&>button]:bg-transparent [&>button]:text-[#143A62] [&>button]:rounded-full [&>button]:hover:bg-blue-200",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation }) =>
          orientation === "left"
            ? <ChevronLeft className="h-4 w-4" />
            : <ChevronRight className="h-4 w-4" />,
        MonthCaption: ({ calendarMonth }) => {
          const date = calendarMonth?.date ?? new Date();
          return (
            <div className="flex flex-col items-center gap-0.5">
              <span className="text-[17px] font-black text-[#143A62] leading-none">{format(date, "MMMM")}</span>
              <span className="text-[12px] font-bold text-slate-400 leading-none">{format(date, "yyyy")}</span>
            </div>
          );
        },
      }}
      {...props}
    />
  );
}

Calendar.displayName = "Calendar"
export { Calendar }
